import React from 'react'
import ReactFitText from 'react-fittext'
import bigMac from '../../../assets/images/big_mac.jpg'
import co2 from '../../../assets/images/co2.jpg'
import calories from '../../../assets/images/world.jpg'
import './StatisticsCard.scss'
import { formatThousands } from '../../../common/helpers/translations'

export interface ICaloriesCardProps {
  value?: string
  pretext?: string
  valuetext?: string
  posttext?: string
  text?: string
  type: 'calories' | 'intensiveMinutes' | 'steps'
}

export class StatisticsCard extends React.PureComponent<ICaloriesCardProps> {
  BEM = () => {
    const classArr = ['statistics-card']
    classArr.push(`statistics-card--${this.props.type}`)

    return classArr.join(' ')
  }

  getIllustration() {
    const { type } = this.props

    switch (type) {
      case 'calories':
        return bigMac
      case 'intensiveMinutes':
        return co2
      case 'steps':
        return calories
      default:
        return
    }
  }

  render() {
    const { type } = this.props
    let { pretext, posttext, value, valuetext, text } = this.props

    if (text) {
      const parts = text.split('<b>')
      if (parts.length > 1) {
        const parts2 = parts[1].split('</b>')
        if (parts2.length > 1) {
          pretext = parts[0]
          text = parts2[0]
          posttext = parts2[1]

          const parts3 = text.split(' (')
          if (parts3[1]) {
            value = parts3[0]
            valuetext = '(' + parts3[1]
          }
        }
      }
    }

    return (
      <div className={this.BEM()}>
        <img
          className={`statistics-card__illustration statistics-card__illustration--${type}`}
          src={this.getIllustration()}
          alt={`${type} card illustration`}
        />
        <div className={`statistics-card__content statistics-card__content--${type}`}>
          <ReactFitText maxFontSize={16}>
            <p className="statistics-card__pretext">{pretext}</p>
          </ReactFitText>

          <ReactFitText compressor={0.5} maxFontSize={24}>
            {value && valuetext ? (
              <p className="statistics-card__value">
                {value} <span className="statistics-card__nowrap">{valuetext}</span>
              </p>
            ) : (
              <p className="statistics-card__value xstatistics-card__nowrap">{text}</p>
            )}
          </ReactFitText>

          <ReactFitText maxFontSize={16}>
            <p className="statistics-card__posttext">{posttext}</p>
          </ReactFitText>
        </div>
      </div>
    )
  }
}
